import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-add-deviations-report',
  templateUrl: './add-deviations-report.component.html',
  styleUrl: './add-deviations-report.component.css'
})
export class AddDeviationsReportComponent implements OnInit {
deviationsForm !: FormGroup;
  selectedDomain = 'Residential'; // default
  domainOptions:any[] = [];
  //  [
  //   'Residential', 'Commercial', 'Educational', 'Water',
  //   'Power', 'Gas', 'Telecom', 'Road', 'Consultancy'
  // ];
  optionsMap: { [key: string]: any[] } = {
    domainOptionsDrp: this.domainOptions
  };

  domainFields: { [key: string]: any[] } = {
    Residential:[
  
  { key: 'unitCountChange', label: 'Unit Count Change', type: 'number', required: false, value: 100 },
  { key: 'layoutAdjustment', label: 'Layout Adjustment', type: 'text', required: false, value: 'Added 3BHK units' }
],
  Commercial: [
  { key: 'retailAreaExpansion', label: 'Retail Area Expansion', type: 'text', required: false, value: '+5,000 sq ft' },
  { key: 'parkingRedesign', label: 'Parking Redesign', type: 'text', required: false, value: 'Multi-level structure' }
]
,
  Educational:[
  { key: 'classroomAddition', label: 'Classroom Addition', type: 'number', required: false, value: 10 },
  { key: 'labRelocation', label: 'Lab Relocation', type: 'text', required: false, value: 'Moved to Block B' }
],
  Water:[
  { key: 'pipelineRouteChange', label: 'Pipeline Route Change', type: 'text', required: false, value: '+2 km rerouting' },
  { key: 'reservoirCapacityUpdate', label: 'Reservoir Capacity Update', type: 'text', required: false, value: 'Increased to 6 million liters' }
]
,
  Power: [
  { key: 'transformerRatingChange', label: 'Transformer Rating Change', type: 'text', required: false, value: '10 MW to 12 MW' },
  { key: 'cableTypeSubstitution', label: 'Cable Type Substitution', type: 'text', required: false, value: 'XLPE instead of PVC' }
]
,
  Gas:[
  { key: 'pressureRatingRevision', label: 'Pressure Rating Revision', type: 'text', required: false, value: '5 bar to 6 bar' },
  { key: 'pipelineMaterialChange', label: 'Pipeline Material Change', type: 'text', required: false, value: 'HDPE to Steel' }
]
,
  Telecom: [
  { key: 'towerRelocation', label: 'Tower Relocation', type: 'text', required: false, value: 'Shifted 200m east' },
  { key: 'fiberRouteAdjustment', label: 'Fiber Route Adjustment', type: 'text', required: false, value: '+1.5 km rerouting' }
]
,
  Road: [
  { key: 'laneCountRevision', label: 'Lane Count Revision', type: 'number', required: false, value: 6 },
  { key: 'medianWidthChange', label: 'Median Width Change', type: 'text', required: false, value: '2m to 3m' }
]
,
  Consultancy: [
  { key: 'scopeExpansion', label: 'Scope Expansion', type: 'text', required: false, value: 'Added post-construction audit' },
  { key: 'timelineExtension', label: 'Timeline Extension', type: 'text', required: false, value: '+2 months' }
]



  };


  commonFields = [
  { key: 'deviationId', label: 'Deviation ID', type: 'text', required: true, value: 'DEV-2025-001' },
  { key: 'projectName', label: 'Project Name', type: 'text', required: true, value: 'SigmaTConflux Smart City Phase 1' },
  { key: 'planningReferenceId', label: 'Planning Reference ID', type: 'text', required: true, value: 'PLAN-2025-045' },
  { key: 'deviationDate', label: 'Deviation Date', type: 'date', required: true, value: '2025-09-15' },
  { key: 'reportedBy', label: 'Reported By', type: 'text', required: true, value: 'Planning Engineer – Zone A' },
  { key: 'natureOfDeviation', label: 'Nature of Deviation', type: 'text', required: true, value: 'Scope Change / Timeline Shift' },
  { key: 'reasonForDeviation', label: 'Reason for Deviation', type: 'text', required: true, value: 'Unexpected soil conditions' },
  { key: 'impactAssessment', label: 'Impact Assessment', type: 'text', required: true, value: '2-week delay, cost increase ₹2,00,000' },
  { key: 'approvalStatus', label: 'Approval Status', type: 'text', required: true, value: 'Pending' },
  { key: 'correctiveAction', label: 'Corrective Action Proposed', type: 'text', required: true, value: 'Rework foundation design' },
  { key: 'revisedTimeline', label: 'Revised Timeline', type: 'dateRange', required: true, value: { start: '2025-09-20', end: '2025-11-15' } },
  { key: 'revisedBudget', label: 'Revised Budget', type: 'currency', required: true, value: 5200000 },
  { key: 'stakeholderNotification', label: 'Stakeholder Notification', type: 'boolean', required: true, value: true },
  { key: 'domain', label: 'Domain', type: 'select', optionKey: 'domainOptionsDrp', required: true, value: 'Residential', onChange: (value: string) => this.onDomainChange(value) }
];

  pickerMap: { [key: string]: MatDatepicker<any> } = {};
  constructor(private fb: FormBuilder, private readonly apiService: ApiService, private readonly toastrMsgService: ToastrMsgService) { }

 ngOnInit(): void {
  this.deviationsForm  = this.fb.group({});
  this.commonFields.forEach(field => {
    const validators = field.required ? [Validators.required] : [];
    this.deviationsForm .addControl(field.key, this.fb.control(field.value || '', validators));
  });
  this.onDomainChange(this.selectedDomain);
}



  onSubmit() {
    if (this.deviationsForm .valid) {
      console.log(this.deviationsForm .value);
    }
  }
  onReset(): void {
    this.deviationsForm .reset();
  }
onDomainChange(domain: string) {
    this.selectedDomain = domain;
    Object.keys(this.deviationsForm .controls).forEach(key => {
      if (key !== 'domain' && this.domainFields[domain]?.find(field => field.key === key) === undefined &&
        Object.values(this.domainFields).flat().some(field => field.key === key)) {
        this.deviationsForm .removeControl(key);
      }
    });
    this.domainFields[domain].forEach(field => {
      this.deviationsForm .addControl(field.key, this.fb.control(field.value));
    });

  }

}
